import React from "react";

/**
 * TD-15: what happened to a funded order, in plain words, from its status.
 * kind: "money" | "airtime"
 */
const COPY = {
  COMPLETED: ["green", "Sent. Your wallet has been charged CUR TOTAL."],
  PARTIALLY_COMPLETED: ["yellow",
    "Part of this order was delivered. You are only charged for what was delivered; the rest is returned to your wallet once confirmed."],
  FAILED: ["red", "This order could not be delivered. The money reserved for it will be returned to your wallet."],
  RECONCILIATION_REQUIRED: ["yellow",
    "We are confirming delivery with our partner. CUR TOTAL stays reserved in your wallet until it is confirmed; you will not be charged twice."],
  PROCESSING: ["blue", "On its way. CUR TOTAL is reserved in your wallet and is taken once delivery is confirmed."],
  FUNDED: ["blue", "Paid from your wallet and queued for delivery."],
};

export default function OrderOutcome({ order }) {
  const o = (order && order.order) || {};
  const [tone, text] = COPY[o.status] || ["blue", "Your order is being processed."];
  const cls = {
    green: "bg-green-50 border-green-200 text-green-800",
    yellow: "bg-yellow-50 border-yellow-200 text-yellow-800",
    red: "bg-red-50 border-red-200 text-red-800",
    blue: "bg-blue-50 border-blue-200 text-blue-800",
  }[tone];
  return (
    <div className={`border p-3 rounded mb-4 text-sm ${cls}`}>
      {text.replace("CUR", o.sourceCurrency || "CAD").replace("TOTAL", o.totalAmount != null ? Number(o.totalAmount).toFixed(2) : "")}
    </div>
  );
}
